/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IHospitalBill } from 'app/shared/model/hospital-bill.model';
import { DiscountType } from 'app/shared/model/enumerations/discount-type.model';
import { BillType } from 'app/shared/model/enumerations/bill-type.model';

export interface IHospitalBillDiscount {
  id?: string;
  discountType?: keyof typeof DiscountType | null;
  billType?: keyof typeof BillType | null;
  discount?: number | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  bill?: IHospitalBill | null;
}

export const defaultValue: Readonly<IHospitalBillDiscount> = {
  active: false,
};
